import React, { useState, useEffect } from 'react';
import CalendarBooking from './CalendarBooking';
import './CalendarBookingModal.css';

const CalendarBookingModal = ({ 
  isOpen, 
  onClose, 
  eventType = 'IELTS',
  eventTitle = "IELTS Consultation",
  duration = 60,
  onBookingComplete,
  restrictedDate = null,
  restrictedTimeSlots = null
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleBookingComplete = (bookingData) => {
    console.log('Booking completed:', bookingData);
    
    // Call the parent callback if provided
    if (onBookingComplete) {
      onBookingComplete(bookingData);
    }
    
    // You can add API calls here to save the booking
    // Example:
    // try {
    //   await fetch('/api/bookings', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(bookingData)
    //   });
    // } catch (error) {
    //   console.error('Failed to save booking:', error);
    // }
  };

  if (!isOpen) return null;

  return (
    <div className={`calendar-modal-overlay ${isVisible ? 'visible' : ''}`}>
      <div className={`calendar-modal ${isVisible ? 'visible' : ''}`}>
        <button 
          className="calendar-modal-close" 
          onClick={handleClose}
          aria-label="Close booking modal"
        >
          ×
        </button>
        
        <CalendarBooking
          eventType={eventType}
          eventTitle={eventTitle}
          duration={duration}
          onBookingComplete={handleBookingComplete}
          restrictedDate={restrictedDate}
          restrictedTimeSlots={restrictedTimeSlots}
        />
      </div>
    </div>
  );
};

export default CalendarBookingModal;
